import { useEffect, type RefObject } from 'react';

/** Quiet compositor light only while the scene is onscreen and the document is visible. */
export function useDiscoverAmbient(root: RefObject<HTMLElement | null>) {
  useEffect(()=>{
    const el=root.current;if(!el||typeof IntersectionObserver==='undefined')return;
    const regions=[...el.querySelectorAll<HTMLElement>('[data-ambient]')];
    const visible=new Set<Element>();
    const update=()=>regions.forEach(region=>region.dataset.ambientActive=String(visible.has(region)&&!document.hidden));
    const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>entry.isIntersecting?visible.add(entry.target):visible.delete(entry.target));update();});
    regions.forEach(region=>observer.observe(region));document.addEventListener('visibilitychange',update);
    return()=>{observer.disconnect();document.removeEventListener('visibilitychange',update);};
  },[root]);
}
